import { parse, format, isValid } from 'date-fns';

class Utility {
  constructor() {}

  static parseJwt(token) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  }

  static isTokenExpired(token) {
    let parsed = this.parseJwt(token);
    return parsed.exp * 1000 < Date.now();
  }

  static formatDateShort(date) {
    let date_ = null;
    if (date instanceof Date) {
      date_ = date;
    } else if (!isNaN(date)) {
      date_ = new Date(Number(date));
    } else {
      date_ = new Date(Date.parse(date));
    }
  
    return `${date_.getMonth() + 1}/${date_.getDate()}/${date_.getFullYear()}`;
  }

// Directly parse the UTC date and convert it to local time.
static timelog(dateString) {
  if (!dateString) return null;

  // Parse the UTC time directly
  const date = new Date(dateString);  // This will automatically treat the string as UTC
  const now = new Date();  // Current local time

  console.log("Current Time", now);
  console.log("Parsed Time (Local Time)", date.toLocaleString());

  const currentTimestamp = now.getTime();
  const retrievedTimestamp = date.getTime();

  const differenceInMs = currentTimestamp - retrievedTimestamp;
  console.log("differenceInMs", differenceInMs);

  // Convert the difference to hours
  const differenceInHours = differenceInMs / (1000 * 60 * 60);
  console.log("differenceInHours", differenceInHours);

  // If more than 24 hours, return the formatted date and time
  if (differenceInHours >= 24) {
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const ampm = hours >= 12 ? 'PM' : 'AM';

    // Convert hours to 12-hour format
    const hours12 = hours % 12;
    const displayHours = hours12 === 0 ? 12 : hours12;

    return `${month.toString().padStart(2, '0')}/${day.toString().padStart(2, '0')}/${year}, ${displayHours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')} ${ampm}`;
      // return date.toLocaleDateString('en-GB') + "," + date.toLocaleTimeString('en-GB');
  } else {
      const remainingHours = Math.floor(differenceInHours);
      const remainingMinutes = Math.floor((differenceInMs % (1000 * 60 * 60)) / (1000 * 60));
      const remainingSeconds = Math.floor((differenceInMs % (1000 * 60)) / 1000);

      console.log(`Difference: ${remainingHours} hours, ${remainingMinutes} minutes, ${remainingSeconds} seconds`);

      if (remainingHours === 0) {
          if (remainingMinutes === 0) {
              return `${remainingSeconds} seconds ago`;
          } else {
              return `${remainingMinutes} minutes ago`;
          }
      } else {
          return `${remainingHours} hours ago`;
      }
  }
}



  static convertUTCToLocal(utcDateString) {
  // Create a Date object directly from the UTC date string
  const utcDate = new Date(utcDateString);

  // Format the date to local time string automatically
  return utcDate.toLocaleString();
  }

  // static convertUTCToLocal(utcDateString) {
  //   try {
  //     const utcDate = new Date(utcDateString);
      
  //     // Use toLocaleString to convert to local time
  //     const localeStringOptions = {
  //       year: 'numeric',
  //       month: '2-digit',
  //       day: '2-digit',
  //       hour: '2-digit',
  //       minute: '2-digit',
  //       second: '2-digit',
  //       hour12: true,
  //     };
      
  //     const localDateString = utcDate.toLocaleString(undefined, localeStringOptions);
      
  //     // Parse local date string using Date-fns
  //     const parsedDate = parse(localDateString, 'MM/dd/yyyy, h:mm:ss aa', new Date());
      
  //     if (isNaN(parsedDate.getTime())) {
  //       throw new Error('Invalid parsed date');
  //     }
      
  //     // Format date using Date-fns
  //     const formattedDate = format(parsedDate, 'MM/dd/yyyy, h:mm:ss aa');
      
  //     return formattedDate;
  //   } catch (error) {
  //     console.error('Error formatting date:', error);
  //     return 'Invalid date';
  //   }
  // }
  

  // static getFormatedTime(unformatedTime) {
  //   let localDate = this.convertUTCToLocal(unformatedTime);
  //   let localTime = localDate.split(", ")[1];
  //   let [ time, timeNotation ] = localTime.split(" ");
  //   let [ hours, minutes ] = time.split(":");
  //   if (hours.length == 1) {
  //     hours = "0" + hours;
  //   }
  //   if (minutes.length == 1) {
  //     minutes = "0" + minutes;
  //   }

  //   let finalTime = `${hours} : ${minutes} ${timeNotation}`;
  //   console.log("finalTime",finalTime);
  //   return finalTime;
  // }
  
  

  static getFormatedTime(unformatedTime) {
    let localDate = new Date(unformatedTime);
    let hours = localDate.getHours();
    let minutes = localDate.getMinutes();
  
    // Pad single-digit values with leading zeros
    hours = hours.toString().padStart(2, '0');
    minutes = minutes.toString().padStart(2, '0');
  
    let timeNotation = hours >= 12 ? 'PM' : 'AM';
  
    // Convert to 12-hour format
    hours = hours % 12;
    if (hours === 0) {
      hours = 12;
    }
  
    let finalTime = `${hours} : ${minutes} ${timeNotation}`;
    console.log("finalTime", finalTime);
    return finalTime;
  }
  

  // static getFormatedTime(unformatedTime) {
  //   let localDate = this.convertUTCToLocal(unformatedTime);
  //   let localTime = localDate.split(", ")[1];
  //   let [time, timeNotation] = localTime.split(" ");
  //   let [hours, minutes] = time.split(":");
    
  //   // Pad single-digit values with leading zeros
  //   if (hours.length == 1) { 
  //     hours = "0" + hours; 
  //   }
  //   if (minutes.length == 1) { 
  //     minutes = "0" + minutes; 
  //   }
    
  //   // Get browser's time notation setting
  //   const timeFormat = new Intl.DateTimeFormat().resolvedOptions().timeStyle;
  //   const is12Hour = timeFormat === 'medium' || timeFormat === 'short';
    
  //   // Convert time notation if necessary
  //   let newTimeNotation;
  //   if (is12Hour) {
  //     newTimeNotation = hours >= 12 ? 'PM' : 'AM';
  //     hours = hours % 12 === 0 ? 12 : hours % 12;
  //   } else {
  //     hours = parseInt(hours);
  //     newTimeNotation = hours >= 12 ? 'AM' : 'PM';
  //     hours = hours % 12 === 0 ? 12 : hours % 12;
  //     if (hours < 10) {
  //       hours = "0" + hours;
  //     }
  //   }
    
  //   let finalTime = `${hours} : ${minutes} ${newTimeNotation}`;
  //   console.log("finalTime", finalTime);
  //   return finalTime;
  // }
  

  static getBrowserDateFormat() {
    const dateFormat = new Intl.DateTimeFormat().formatToParts(new Date());
    const monthIndex = dateFormat.findIndex(part => part.type === 'month');
    const dayIndex = dateFormat.findIndex(part => part.type === 'day');
  
    return monthIndex < dayIndex ? 'MM/dd/yyyy' : 'dd/MM/yyyy';
  }
  
  static getFormatedDate(unformattedDate) {
    const browserDateFormat = this.getBrowserDateFormat();
    let localDate = unformattedDate.split(",")[0];
    let localDateArr = localDate.split("/");
    let month, actualDate, year;
  
    // Adjust date parts based on browser's date format setting
    if (browserDateFormat === 'MM/dd/yyyy') {
      month = localDateArr[0];
      actualDate = localDateArr[1];
      year = localDateArr[2];
    } else {
      actualDate = localDateArr[0];
      month = localDateArr[1];
      year = localDateArr[2];
    }
  
    // Pad single-digit values with leading zeros
    if (month.length == 1) { 
      month = "0" + month; 
    }
    if (actualDate.length == 1) { 
      actualDate = "0" + actualDate; 
    }
  
    // Ensure year has 4 digits
    if (year.length == 1) { 
      year = "000" + actualDate; 
    } else if (year.length == 2) { 
      year = "20" + year; 
    } else if (year.length == 3) { 
      year = "0" + year; 
    }
  
    // Format date as MM/DD/YYYY
    let formattedDate = month + "/" + actualDate + "/" + year;
  
    return formattedDate;
  }
  
}


export default Utility;
